import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import some from 'lodash/some';

import { Button } from 'primereact/button';

import ListUserModal from '@components/Admins/ListUserModal'

import { getValueLanguageObj } from '@utils/general'

import { StatusString } from '@constants/general'

class userForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modalListUser: {
        isVisible: false
      }
    };
  }

  componentDidMount() {
    const { user, isEdit } = this.props
    if (!user && !isEdit) this.openModalSearchUser()
    this.setState({ loadingPage: false });
  }


  onSubmit = async (e) => {
    e.preventDefault();
    const { success } = this.props;
    const validate = await this.validateFields();
    if (some(validate, {})) return true;
    await this.setValuesToStateGlobal();
    success();
  };

  openModalSearchUser = () => {
    this.setState({ modalListUser: { isVisible: true } })
  }

  validateStatus = () => {
    const { user, t } = this.props
    if (user?.estatus === StatusString.STATUS_SUSPENDED) {
      return (<span className="badge-red" aria-hidden="true"> {t('Suspendido').toUpperCase()} </span>
      )
    }
    if (user?.estatus === StatusString.STATUS_ACTIVE) {
      return (<span  aria-hidden="true"> {t('Activo')} </span>)
    }
    return 'N/A'
  }

  render() {
    const { t, btnSubmitLoading, history, user, success, isEdit } = this.props;

    const { loadingPage, modalListUser } = this.state;

    if (loadingPage) return true;

    return (
      <>
        { !isEdit && (
          <div className="p-col-12 p-text-right">
            <Button
              label={t('Buscar usuario')}
              type="button"
              icon="pi pi-search"
              className="p-button-info"
              onClick={() => this.openModalSearchUser()}
              loading={btnSubmitLoading}
            />
          </div>
        )}
        <div className="p-fluid p-grid p-mb-4">
          <div className="p-col-6 p-mb-5">
            <label className="p-text-bold">{t('Nombre')}</label> <br/>
            <label>{user?.nombre || 'N/A'} </label>
          </div>
          <div className="p-col-6" />
          <div className="p-col-6 p-mb-5">
            <label className="p-text-bold">{t('País')}</label> <br/>
            <label>{user?.pais ? getValueLanguageObj(JSON.parse(user?.pais)) : 'N/A'}</label>
          </div>
          <div className="p-col-6 p-mb-5">
            <label className="p-text-bold">{t('Empresa')}</label> <br/>
            <label>{user?.empresa || 'N/A'}</label>
          </div>
          <div className="p-col-6 p-mb-5">
            <label className="p-text-bold">{t('Correo electrónico')}</label> <br/>
            <label>{user?.correo || 'N/A'}</label>
          </div>
          <div className="p-col-6 p-mb-5">
            <label className="p-text-bold">{t('Puesto')}</label> <br/>
            <label>{user?.puesto || 'N/A'}</label>
          </div>
          <div className="p-col-6 p-mb-5">
            <label className="p-text-bold">{t('Estatus')}</label> <br/>
            <label>{this.validateStatus()}</label>
          </div>
        </div>
        <div className="p-col-12 footer-btn">
          <div className="p-d-flex p-jc-between">
            <Button
              label={t('Cancelar')}
              type="button"
              className="p-button-secondary"
              onClick={() => history.push('/admins')}
            />
            <Button
              label={t('Continuar')}
              type="button"
              onClick={() => user ? success() : ''}
              className="p-button-primary"
              loading={btnSubmitLoading}
            />
          </div>
        </div>
      { modalListUser.isVisible && (
        <ListUserModal
          onHidden={() => this.setState({ modalListUser: { isVisible: false } })}
        />
      )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.admins.user,
});

const mapDispatchToProps = {};

export default withRouter(
  compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
  )(userForm)
);
